import { isPC } from '@/utils'
if (isPC()) {
  window.location.href = 'https://www.shangminet.com/home'
}
